
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 52 57","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M40.733 24.577h9.23v30H1.502v-30h9.231M26.886 1.501v41.538"}}),_c('path',{attrs:{"d":"M38.425 31.501L26.886 43.039 15.348 31.501"}})])])
          )
        }
      }
    